<template>
  <div>
    <bs-card class="card-info" :icon="['fal', 'location']" :label="$t('labels.' + camelToSnake($options.name))">
      <bs-table v-bind="{dataLength, loading}" :cols="5">
        <template v-slot:thead>
          <tr>
            <bs-th>{{ $t('labels.state') }}</bs-th>
            <bs-th>{{ $t('labels.from') }}</bs-th>
            <bs-th>{{ $t('labels.to') }}</bs-th>
            <bs-th>{{ $t('labels.time') }}</bs-th>
            <bs-th>{{ $t('labels.address') }}</bs-th>
          </tr>
        </template>
        <tr v-for="r in resources.data" :key="r.id">
          <td>{{ $t('labels.' + r.status) }}</td>
          <td>{{ dtFull(r.from) }}</td>
          <td>{{ dtFull(r.to) }}</td>
          <td>{{ secondsToTime(r.time) }}</td>
          <td>{{ r.address }}</td>
        </tr>
        <template v-slot:tfoot>
            <pagination :data="resources" :state="resourceState" @pushPage="index"></pagination>
        </template>
      </bs-table>
    </bs-card>

  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { DateTime } from 'luxon'

export default {
  name: 'VehicleEvents',
  props: ['vehicle'],
  data () {
    return {
      loading: false,
      dataLoading: false
    }
  },
  mounted () {
    this.index()
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      resourceState: state => state.vehicleEventsState,
      resources: state => state.vehicleEvents,
      submitting: state => state.submitting
    }),
    dataLength () {
      let length = 0
      if (this.resources.data) length = this.resources.data.length
      return Math.max(this.resourceState.tableRows - length, 0)
    }
  },
  methods: {
    timeFormat (dt) {
      return DateTime.fromISO(dt).toFormat('FFF')
    },
    applySort (val) {
      this.pushState({ view: this.$options.name, key: 'sort', data: val })
      this.index()
    },
    ...mapMutations([
      'pushState'
    ]),
    index (page, count) {
      if (page) this.pushState({ view: this.$options.name, key: 'page', data: page })
      if (count) this.pushState({ view: this.$options.name, key: 'tableRows', data: count })
      this.loading = true
      this.$store.dispatch('index', { collection: this.$options.name, path: 'vehicles', id: this.vehicle, tag: 'vehicle-events' }).then(() => {
        this.loading = false
      })
    }
  }
}
</script>
